import Vuex from 'vuex';
import Vue from 'vue';
import search from './modules/search';
import 'core-js/es6/array';

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    search
  }
});
